import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/vue-query'
import { HR_EMPLOYEE_NOTIFICATIONS } from '../employeeNotificationEndpoints'
import {
  EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_QUERY_KEY,
  EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY,
} from '../employeeNotificationQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export function deleteAllEmployeeNotifications(): Promise<void> {
  return axiosInstance.delete(HR_EMPLOYEE_NOTIFICATIONS).then(() => undefined)
}

export function useDeleteAllEmployeeNotificationsMutation(
  options?: UseMutationOptions<void, AxiosCustomError, void>
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteAllEmployeeNotifications,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_LATEST_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
      })
    },
  })
}
